export const IconExcel = (
  <svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.5 0.5H0.5V39.5H28.5V9.5M19.5 0.5L28.5 9.5M19.5 0.5V9.5H28.5M14.5 24.5L10.5 20.5M14.5 24.5L18.5 20.5M14.5 24.5L10.5 28.5M14.5 24.5L18.5 28.5"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconPdf = (
  <svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.5 0.5H0.5V39.5H28.5V9.5M19.5 0.5L28.5 9.5M19.5 0.5V9.5H28.5M13.3333 21.7763C12.7973 21.151 12.0911 19.3487 12.6326 17.8212C12.8784 17.128 13.7995 17.1177 14.0551 17.8073C14.6221 19.3372 13.871 21.1473 13.3333 21.7763ZM13.3333 21.7763C13.6643 22.6594 14.7745 24.6684 16.6007 25.765M13.3333 21.7763C12.5574 24.0067 11.8372 25.7637 11.1808 27.1193M16.6007 25.765C16.6368 25.7867 16.6732 25.808 16.7099 25.8289C19.0739 27.1798 22.4511 27.5175 21.438 26.1667C20.8059 25.3239 19.1662 25.2757 16.6007 25.765ZM16.6007 25.765C15.1038 26.0505 13.2917 26.5189 11.1808 27.1193M11.1808 27.1193C11.1104 27.1394 11.0397 27.1595 10.9687 27.1798C8.60586 27.8553 6.57947 29.8816 7.59261 30.8947C8.31417 31.3762 9.55107 30.4848 11.1808 27.1193Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconWord = (
  <svg width="33" height="40" viewBox="0 0 33 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3993_3516)">
      <path
        d="M20.166 0.5H1.16602V39.5H29.166V9.5M20.166 0.5L29.166 9.5M20.166 0.5V9.5H29.166M21.166 20.5L18.166 28.5L15.166 20.5L12.166 28.5L9.16602 20.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3993_3516">
        <rect width="32" height="40" fill="white" transform="translate(0.666016)" />
      </clipPath>
    </defs>
  </svg>
);

export const IconDownload = (
  <svg width="33" height="40" viewBox="0 0 33 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.668 20L16.668 28M16.668 28L8.66797 20M16.668 28V4"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M28.668 36H4.66797" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
